var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMapPinLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / line / map-pin-2-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66504 15.8188L4.4224 11.5762C2.07925 9.23296 2.07925 5.434 4.4224 3.09086C6.76555 0.747709 10.5645 0.747709 12.9077 3.09086C15.2508 5.434 15.2508 9.23296 12.9077 11.5762L8.66504 15.8188ZM11.9648 10.6333C13.7873 8.8109 13.7873 5.85611 11.9648 4.03366C10.1424 2.21122 7.18765 2.21122 5.36521 4.03366C3.54276 5.85611 3.54276 8.8109 5.36521 10.6333L8.66504 13.9332L11.9648 10.6333ZM8.66504 8.66683C7.92864 8.66683 7.33171 8.0699 7.33171 7.3335C7.33171 6.59712 7.92864 6.00016 8.66504 6.00016C9.40144 6.00016 9.99837 6.59712 9.99837 7.3335C9.99837 8.0699 9.40144 8.66683 8.66504 8.66683Z",
    fill: "#A3A3A3"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMapPinLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/map-pin-line.2a62b4e7.svg";
export { ForwardRef as ReactComponent };